module.exports = __webpack_public_path__ + "static/img/040_TO8_1534.a463e12.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/040_TO8_1534.jpg
// module id = s5he
// module chunks = 0